import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { RadioField } from 'src/jbc-front/components/Form';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';

import MotivationSteppedBonus from './components/MotivationSteppedBonus/MotivationSteppedBonus';

import './AllowanceMotivation.scss';

const AllowanceMotivation = ({ motivationTypes, selectedMotivationType, t }) => (
  <div>
    <RadioField
      label={t('features.ClientMotivation.components.AllowanceMotivation.motivation_bonus_type')}
      name="motivationType"
      required
      options={motivationTypes}
    />
    {selectedMotivationType === 'monthly_stepped_bonus' && <MotivationSteppedBonus />}
  </div>
);

const mapStateToProps = state => ({
  motivationTypes: getSelectOptions(state, 'motivationTypes'),
  selectedMotivationType: selector(getAllowanceFormValues(state), 'motivationType')
});

export default withTranslation()(connect(mapStateToProps)(AllowanceMotivation));
